import { render, staticRenderFns } from "./zifuchuan.vue?vue&type=template&id=aad9d63c&scoped=true&"
import script from "./zifuchuan.vue?vue&type=script&lang=ts&"
export * from "./zifuchuan.vue?vue&type=script&lang=ts&"
import style0 from "./zifuchuan.vue?vue&type=style&index=0&id=aad9d63c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad9d63c",
  null
  
)

export default component.exports